'use strict';

import { ISiteDto_Props } from './SiteDto.if';
import { IModelSource } from '../interface/db';
import DBUtil from '../private/db.util';
import IMediumDto from './MediumDto.if';
import MediumDto from './MediumDto';
import IScreenOrientationDto from './ScreenOrientationDto.if';
import ScreenOrientationDto from './ScreenOrientationDto';
import IStyleDto from './StyleDto.if';
import StyleDto from './StyleDto';
import ISiteSupportedLanguageDto from './SiteSupportedLanguageDto.if';
import SiteSupportedLanguageDto from './SiteSupportedLanguageDto';

export interface ISiteDto_Linkables {
    imageLogo: (db: IModelSource) => Promise<IMediumDto>;
    screenOrientation: (db: IModelSource) => Promise<IScreenOrientationDto>;
    languageSelectionStyle: (db: IModelSource) => Promise<IStyleDto>;
    tourSelectionStyle: (db: IModelSource) => Promise<IStyleDto>;
    siteSupportedLanguages: (db: IModelSource) => Promise<ISiteSupportedLanguageDto[]>;
}

function _imageLogo(this: Partial<ISiteDto_Props>, db: IModelSource): Promise<IMediumDto> {
    return this.logoMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.logoMediumId, MediumDto)
        : Promise.reject('Missing field site.logoMediumId');
}

function _screenOrientation(
    this: Partial<ISiteDto_Props>,
    db: IModelSource,
): Promise<IScreenOrientationDto> {
    return this.screenOrientationId
        ? DBUtil.loadScreenOrientationId<IScreenOrientationDto>(
              db,
              this.screenOrientationId,
              ScreenOrientationDto,
          )
        : Promise.reject('Missing field site.screenOrientationId');
}

function _languageSelectionStyle(
    this: Partial<ISiteDto_Props>,
    db: IModelSource,
): Promise<IStyleDto> {
    return this.languageSelectionStyleId
        ? DBUtil.loadStyleId<IStyleDto>(db, this.languageSelectionStyleId, StyleDto)
        : Promise.reject('Missing field site.languageSelectionStyleId');
}

function _tourSelectionStyle(this: Partial<ISiteDto_Props>, db: IModelSource): Promise<IStyleDto> {
    return this.tourSelectionStyleId
        ? DBUtil.loadStyleId<IStyleDto>(db, this.tourSelectionStyleId, StyleDto)
        : Promise.reject('Missing field site.tourSelectionStyleId');
}

function _siteSupportedLanguages(
    this: Partial<ISiteDto_Props>,
    db: IModelSource,
): Promise<ISiteSupportedLanguageDto[]> {
    if (!this.id) {
        return Promise.reject('Missing gield site.id');
    }

    const self = this;
    return new Promise(async function (resolve, reject) {
        try {
            const ssl = await DBUtil.allSiteSupportedLanguages<ISiteSupportedLanguageDto>(
                db,
                SiteSupportedLanguageDto,
            );
            const sslMatch = ssl.filter(x => x.siteId === self.id);
            resolve(sslMatch);
        } catch (error) {
            reject(error);
        }
    });
}

/** 
 * @description all custom properties for
   SiteDto & methods to link against other entities
*/
function linkables(model: Partial<ISiteDto_Props>): ISiteDto_Linkables {
    return {
        imageLogo: _imageLogo.bind(model),
        screenOrientation: _screenOrientation.bind(model),
        languageSelectionStyle: _languageSelectionStyle.bind(model),
        tourSelectionStyle: _tourSelectionStyle.bind(model),
        siteSupportedLanguages: _siteSupportedLanguages.bind(model),
    };
}

export default linkables;
